import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { getUrl, setJwtToken, TProduct } from '../config'
import type { DeleteBody, GetPageBody } from '../model/catalogTypes'

import { GenerateRequest } from './requests'
import type { TFilterOption } from '../model'

//!!! Миш. Поставь свой

export const catalogFeatureApi = createApi({
    reducerPath: 'catalogFeatureApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API,
        prepareHeaders: setJwtToken
    }),
    tagTypes: ['PRODUCTS'],
    endpoints: builder => ({
        filterProducts: builder.query<{ data: TProduct[]; count: number }, GetPageBody>({
            query: body => {
                const req = GenerateRequest({
                    type: 'getPage',
                    body: {
                        page: body.page,
                        count: body.count,
                        filter: body.filter,
                        animalType: body.animalType,
                        searchValue: body.searchValue,
                        ...(body.sort && { sort: body.sort })
                    }
                })
                if (req) {
                    return {
                        url: req.url,
                        method: 'GET'
                    }
                }
                return {
                    url: getUrl,
                    method: 'GET'
                }
            }
        }),
        deleteProducts: builder.mutation<void, DeleteBody>({
            query: data => {
                const req = GenerateRequest({ type: 'delete', body: { id: data?.id } })
                if (req) {
                    return {
                        url: req.url,
                        method: 'DELETE',
                        body: data
                    }
                }
                return { url: '' }
            },
            extraOptions: { includeToken: true },
            invalidatesTags: ['PRODUCTS']
        }),
        updateProduct: builder.mutation<any, Partial<TProduct>>({
            query: data => {
                const req = GenerateRequest({ type: 'update', body: { data: data } })
                if (req) {
                    return { url: `/product/${data.id}`, method: 'PATCH', body: data }
                }
                return { url: '' }
            },
            extraOptions: { includeToken: true },
            invalidatesTags: ['PRODUCTS']
        })
    })
})

export const { useFilterProductsQuery, useDeleteProductsMutation, useUpdateProductMutation } = catalogFeatureApi
